import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

// MSAL CONFIG
const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
         authority: process.env.REACT_APP_AUTHORITY,
         redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage", 
        storeAuthStateInCookie: true
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (!containsPii) console.log(message);
            },
            logLevel: LogLevel.Info,
        },
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);

await msalInstance.initialize();